import { useState } from "react";
import { Link } from "react-router-dom";
import { money0 } from "../../api";
import { EmptyLine, HomeSection, Prio, plural } from "./HomeBits";

const slug = (s = "") => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "").slice(0, 40);

function Row({ a, i }) {
  const meta = [a.project, a.person].filter(Boolean).join(" · ");
  return (
    <div className="att-item" data-testid={`needs-attention-item-${slug(a.title) || i}`} data-priority={a.priority}>
      <Prio level={a.priority} />
      <div className="min-w-0 flex-1">
        <div className="t1 truncate text-[13.5px] font-medium">{a.title}</div>
        <div className="t3 truncate text-[12px]">{a.sub}{meta ? <span className="t4"> · {meta}</span> : null}</div>
      </div>
      {a.amount > 0 && <span className="money t2 hidden shrink-0 text-[13px] sm:block">{money0(a.amount)}</span>}
      <Link to={a.link} className="btn-secondary btn-sm shrink-0 whitespace-nowrap" data-testid={`attention-action-${i}`}>{a.action}</Link>
    </div>
  );
}

// One consolidated list. Critical and Important only; anything else is folded away behind one line.
export function Attention({ items, other = [], className = "" }) {
  const [showOther, setShowOther] = useState(false);
  return (
    <HomeSection title="Needs attention" count={items.length ? plural(items.length, "item") : null} testid="needs-attention" className={className}>
      {items.length === 0 ? <EmptyLine testid="needs-attention-empty">Nothing needs your attention right now.</EmptyLine> : <div>{items.map((a, i) => <Row key={i} a={a} i={i} />)}</div>}
      {other.length > 0 && (
        <div className="border-t border-line">
          <button type="button" onClick={() => setShowOther((s) => !s)} className="t3 flex w-full items-center justify-between px-4 py-2 text-[12px] font-medium hover:bg-surface-2" data-testid="attention-more-toggle" aria-expanded={showOther}>
            <span>{plural(other.length, "lower-priority item")}</span><span>{showOther ? "Hide" : "Show"}</span>
          </button>
          {showOther && <div className="border-t border-line" data-testid="attention-more">{other.map((a, i) => <Row key={i} a={a} i={items.length + i} />)}</div>}
        </div>
      )}
    </HomeSection>
  );
}
